const COUNTRIES_API_URL = "https://countriesnow.space/api/v0.1/countries"
export const API_CONFIG = {
    COUNTRIES_API: COUNTRIES_API_URL,
    STATES_API: COUNTRIES_API_URL+'/states',
    CITIES_API: COUNTRIES_API_URL+'/state/cities',
};